export default __webpack_public_path__ + "static/media/chef.6dbd89e2.svg";